import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Modal from "react-modal";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import {
  convertStraight,
  convertToYYYYMMDD,
} from "../../../components/common-data/Converts";
import { fetchApiDataDup } from "../../../redux/reducers/commonApiSlice";
import {
  attendanceGet,
  attendanceTrainerGet,
} from "../../../data/ApiEndpoints";
import MemberCheckinLogs from "../../../components/pt-trials/common/MemberCheckinLogs";
import ModalHeadAndClose from "../../../components/payouts-wtf/common/ModalHeadAndClose";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../../../components/common-components/ReactVortoxSpinner";
import CheckinsStatCards from "./checkins-stats/CheckinsStatCards";
import { fetchCheckinsStatData } from "../../../redux/dashboard-features/featuresSlice";

const TabViewCheckins = ({
  user,
  clickedCard,
  tbFilters,
  isPage,
  setIsPage,
  registerApiCall,
}) => {
  const dispatch = useDispatch();
  const { dataDup, loadingDup, errorDup } = useSelector(
    (state) => state.common
  );

  const [selectedTab, setSelectedTab] = useState(0);
  const initialClickValues = {
    userId: "",
    type: "",
    cardType: "",
    detailsArray: [],
    isModOpen: false,
  };
  const [clickValues, setClickValues] = useState(initialClickValues);
  const [sendableStatsQPs, setSendableStatsQPs] = useState("");
  const iniTbDatas = {
    allData: null,
    pagination: [],
    totalSale: 0,
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  const onCloseModal = () => {
    setClickValues(initialClickValues);
  };

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    setIsPage(0);
  };

  function getCheckinsStatData(filters) {
    const { filter_type, ...rest } = filters;

    dispatch(
      fetchCheckinsStatData({
        filters: rest,
        token: user?.token,
      })
    );
  }

  function getCheckinDetails(filtersToSend) {
    dispatch(
      fetchApiDataDup({
        method: "GET",
        endpoint: selectedTab === 4 ? attendanceTrainerGet : attendanceGet,
        payload: {
          filters: filtersToSend,
        },
        token: user?.token,
      })
    );
  }

  useEffect(() => {
    getCheckinsStatData(tbFilters);
  }, [tbFilters]);

  useEffect(() => {
    if (
      tbFilters?.filter_type &&
      clickedCard === "checkins" &&
      (selectedTab || selectedTab === 0)
    ) {
      let filtersToSend = { ...tbFilters };

      if (clickedCard === "checkins" && selectedTab !== 4) {
        delete filtersToSend.filter_type;
        filtersToSend.date_from = tbFilters.start_date
          ? convertStraight(tbFilters.start_date)
          : "";
        filtersToSend.date_to = tbFilters.end_date
          ? convertStraight(tbFilters.end_date)
          : "";
        filtersToSend.account_type =
          selectedTab === 0
            ? "member"
            : selectedTab === 1
            ? "guest"
            : selectedTab === 2
            ? "trainer"
            : selectedTab === 3
            ? "receptionist"
            : selectedTab === 5
            ? "housekeeping"
            : selectedTab === 6
            ? "gyms"
            : selectedTab === 7
            ? "admin"
            : "";
        delete filtersToSend.start_date;
        delete filtersToSend.end_date;
      } else if (selectedTab === 4) {
        delete filtersToSend.filter_type;
        filtersToSend.date_from = tbFilters.start_date
          ? tbFilters.start_date
          : "";
        filtersToSend.date_to = tbFilters.end_date ? tbFilters.end_date : "";
        delete filtersToSend.start_date;
        delete filtersToSend.end_date;
      }

      getCheckinDetails(filtersToSend);
    }
  }, [selectedTab, tbFilters]);

  useEffect(() => {
    if (
      registerApiCall &&
      tbFilters?.filter_type &&
      clickedCard === "checkins" &&
      (selectedTab || selectedTab === 0)
    ) {
      let filtersToSend = { ...tbFilters };

      if (clickedCard === "checkins" && selectedTab !== 4) {
        delete filtersToSend.filter_type;
        filtersToSend.date_from = tbFilters.start_date
          ? convertStraight(tbFilters.start_date)
          : "";
        filtersToSend.date_to = tbFilters.end_date
          ? convertStraight(tbFilters.end_date)
          : "";
        filtersToSend.account_type =
          selectedTab === 0
            ? "member"
            : selectedTab === 1
            ? "guest"
            : selectedTab === 2
            ? "trainer"
            : selectedTab === 3
            ? "receptionist"
            : selectedTab === 5
            ? "housekeeping"
            : selectedTab === 6
            ? "gyms"
            : selectedTab === 7
            ? "admin"
            : "";
        delete filtersToSend.start_date;
        delete filtersToSend.end_date;
      } else if (selectedTab === 4) {
        delete filtersToSend.filter_type;
        filtersToSend.date_from = tbFilters.start_date
          ? tbFilters.start_date
          : "";
        filtersToSend.date_to = tbFilters.end_date ? tbFilters.end_date : "";
        delete filtersToSend.start_date;
        delete filtersToSend.end_date;
      }

      registerApiCall(() => {
        getCheckinsStatData(tbFilters);
        getCheckinDetails(filtersToSend);
      });
    }
  }, []);

  useEffect(() => {
    if (dataDup?.status && !errorDup) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: dataDup?.data,
        pagination: dataDup?.pagination?.length > 0 ? dataDup.pagination : [],
        totalSale: dataDup?.total ? dataDup.total : 0,
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [dataDup, errorDup]);

  useEffect(() => {
    if (tbFilters?.start_date || tbFilters?.end_date) {
      const startDateQp = tbFilters?.start_date
        ? convertToYYYYMMDD(tbFilters.start_date)
        : "";
      const endDateQp = tbFilters?.end_date
        ? convertToYYYYMMDD(tbFilters.end_date)
        : "";
      setSendableStatsQPs(`${startDateQp}${endDateQp}`);
    }
  }, [tbFilters]);

  const checkinsTbColumns = [
    {
      dataField: "user_name",
      text: "Member Info",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth120">
            {row?.user_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.role !== "guest" ? row?.email || "" : null}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "checkin date/time",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.date || "-"}
            <br />
            {row?.role === "member" ||
            row?.role === "guest" ||
            row?.role === "housekeeping" ||
            row?.role === "gyms" ||
            row?.role === "admin" ? (
              <small
                className="hoverBlue bold"
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() =>
                  setClickValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    userId: row?.user_id,
                    type: row?.role,
                  }))
                }>
                (
                {row?.role === "member" || row?.role === "guest"
                  ? row.time || "-"
                  : row.checkin_time || "-"}
                )
              </small>
            ) : null}
          </span>
        );
      },
    },
    {
      dataField: "role",
      text: "role",
      formatter: (cell, row) => {
        let shiftTimings = [];
        if (row?.role === "receptionist") {
          shiftTimings = row?.receceptionist_shift?.map((shift) => {
            const startTime = shift?.shift_start
              ? moment(shift.shift_start, "HH:mm")
                  .tz("Asia/Kolkata")
                  .format("h:mmA")
              : "";
            const endTime = shift?.shift_end
              ? moment(shift.shift_end, "HH:mm")
                  .tz("Asia/Kolkata")
                  .format("h:mmA")
              : "";
            return `${startTime}-${endTime}`;
          });
        } else {
          const activeShifts = row?.shift_details?.filter(
            (shift) => shift.status === "active"
          );
          if (activeShifts && activeShifts?.length > 0) {
            shiftTimings = activeShifts?.map((shift) => {
              const startTime = shift?.start_time
                ? moment(shift.start_time, "HH:mm")
                    .tz("Asia/Kolkata")
                    .format("h:mmA")
                : "";
              const endTime = shift?.end_time
                ? moment(shift.end_time, "HH:mm")
                    .tz("Asia/Kolkata")
                    .format("h:mmA")
                : "";
              return `${startTime}-${endTime}`;
            });
          }
        }

        shiftTimings = shiftTimings
          ? [...new Set(shiftTimings?.filter((timing) => timing !== "-"))]
          : [];

        const shiftTiming =
          shiftTimings?.length > 0
            ? shiftTimings?.join(", ")
            : "No Shift Found";

        return (
          <span className="tb-data minWidth150 bold">
            {row?.role === "receptionist"
              ? "Sales Executive"
              : row?.role?.replace(/_/g, " ") || "NA"}
            <br />
            {row?.role === "receptionist" || row?.role === "trainer" ? (
              <small
                className="hoverBlue"
                style={{
                  fontWeight: "500",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() =>
                  setClickValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    userId: row?.user_id,
                    type:
                      row?.role === "receptionist"
                        ? "Sales Executive"
                        : row?.role,
                  }))
                }>
                {shiftTiming}
              </small>
            ) : null}
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
  ];

  const checkinsTbColumnsStaff = [
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "name",
      text: "Member Info",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth120">
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.role !== "guest" ? row?.email || "" : null}
            </small>
          </span>
        );
      },
    },
    // {
    //   dataField: "salary",
    //   text: "Salary(Package)",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data minWidth100">
    //         ₹{convertThenFormat(row?.salary || 0)}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "account_type",
      text: "role",
      formatter: (cell, row) => {
        const shiftTimings = row?.shift_details?.map((shift) => {
          const startTime = shift?.start_time
            ? moment(shift.start_time, "HH:mm")
                .tz("Asia/Kolkata")
                .format("h:mmA")
            : "";
          const endTime = shift?.end_time
            ? moment(shift.end_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
            : "";
          return `${startTime}-${endTime}`;
        });

        const shiftTiming = shiftTimings
          ? shiftTimings?.join(", ")
          : "No Shift Found";

        return (
          <span className="tb-data minWidth150 bold">
            {row?.account_type === "receptionist"
              ? "Sales Executive"
              : row?.account_type?.replace(/_/g, " ") || "NA"}
            <br />

            <small
              className="hoverBlue"
              style={{
                fontWeight: "500",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  userId: row?.user_id,
                  type:
                    row?.account_type === "receptionist"
                      ? "Sales Executive"
                      : row?.account_type,
                }))
              }>
              {shiftTiming}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon view"
            onClick={(e) =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardType: "view",
                detailsArray:
                  row?.attendance_details?.length > 0
                    ? row.attendance_details
                    : [],
              }))
            }
            style={{
              border:
                row?.attendance_details?.length > 0
                  ? "1px solid #bc0909"
                  : "1px solid #9C9C9C",
              color:
                row?.attendance_details?.length > 0 ? "#bc0909" : "#9C9C9C",
              borderRadius: "12px",
              cursor:
                row?.attendance_details?.length > 0 ? "pointer" : "not-allowed",
            }}
            disabled={row?.attendance_details?.length === 0}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrows-angle-expand"
              viewBox="0 0 16 16"
              style={{
                color:
                  row?.attendance_details?.length > 0 ? "#bc0909" : "#9C9C9C",
                width: "20px",
                height: "20px",
              }}>
              <path
                fillRule="evenodd"
                d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
              />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  const attendanceTbColumns = [
    {
      dataField: "date",
      text: "Date",
      formatter: (cell, row) => {
        return <span className="tb-data minWidth150">{row?.date || "-"}</span>;
      },
    },
    {
      dataField: "time",
      text: "time",
      formatter: (cell, row) => {
        return <span className="tb-data minWidth150">{row?.time || "-"}</span>;
      },
    },
    {
      dataField: "shift_type",
      text: "shift type",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.shift_type || "NA"}</span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Checkin Details Modal"
        ariaHideApp={false}>
        <div className="createNewCTOModalContainer minWidth80vw">
          <ModalHeadAndClose
            title={`${clickValues.type} Checkin Logs`}
            onClose={onCloseModal}
          />

          {clickValues.cardType === "view" ? (
            <div className="overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={clickValues.detailsArray}
                tableColumns={attendanceTbColumns}
              />
            </div>
          ) : clickValues?.userId ? (
            <MemberCheckinLogs
              clickValues={clickValues}
              sendableStatsQPs={sendableStatsQPs}
            />
          ) : (
            <></>
          )}
        </div>
      </Modal>

      <CheckinsStatCards userInfoData={user} filters={tbFilters} />

      <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
        <TabList>
          <Tab>Members</Tab>
          <Tab>Guest</Tab>
          <Tab>Trainer</Tab>
          <Tab>Staff</Tab>
          <Tab>Trainers/Sales Executives Logs</Tab>
          <Tab>housekeeping</Tab>
          <Tab>Gym Owner</Tab>
          <Tab>Admin</Tab>
        </TabList>

        <TabPanel>
          {loadingDup ? (
            <ReactVortoxSpinner />
          ) : (
            <div className="overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={tbDatas.allData}
                tableColumns={checkinsTbColumns}
                isPage={isPage}
                setIsPage={setIsPage}
                tablePagination={tbDatas.pagination}
              />
            </div>
          )}
        </TabPanel>

        <TabPanel>
          {loadingDup ? (
            <ReactVortoxSpinner />
          ) : (
            <div className="overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={tbDatas.allData}
                tableColumns={checkinsTbColumns}
                isPage={isPage}
                setIsPage={setIsPage}
                tablePagination={tbDatas.pagination}
              />
            </div>
          )}
        </TabPanel>

        <TabPanel>
          {loadingDup ? (
            <ReactVortoxSpinner />
          ) : (
            <div className="overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={tbDatas.allData}
                tableColumns={checkinsTbColumns}
                isPage={isPage}
                setIsPage={setIsPage}
                tablePagination={tbDatas.pagination}
              />
            </div>
          )}
        </TabPanel>

        <TabPanel>
          {loadingDup ? (
            <ReactVortoxSpinner />
          ) : (
            <div className="overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={tbDatas.allData}
                tableColumns={checkinsTbColumns}
                isPage={isPage}
                setIsPage={setIsPage}
                tablePagination={tbDatas.pagination}
              />
            </div>
          )}
        </TabPanel>

        <TabPanel>
          {loadingDup ? (
            <ReactVortoxSpinner />
          ) : (
            <div className="overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={tbDatas.allData}
                tableColumns={checkinsTbColumnsStaff}
                isPage={isPage}
                setIsPage={setIsPage}
                tablePagination={tbDatas.pagination}
              />
            </div>
          )}
        </TabPanel>

        <TabPanel>
          {loadingDup ? (
            <ReactVortoxSpinner />
          ) : (
            <div className="overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={tbDatas.allData}
                tableColumns={checkinsTbColumns}
                isPage={isPage}
                setIsPage={setIsPage}
                tablePagination={tbDatas.pagination}
              />
            </div>
          )}
        </TabPanel>

        <TabPanel>
          {loadingDup ? (
            <ReactVortoxSpinner />
          ) : (
            <div className="overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={tbDatas.allData}
                tableColumns={checkinsTbColumns}
                isPage={isPage}
                setIsPage={setIsPage}
                tablePagination={tbDatas.pagination}
              />
            </div>
          )}
        </TabPanel>

        <TabPanel>
          {loadingDup ? (
            <ReactVortoxSpinner />
          ) : (
            <div className="overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={tbDatas.allData}
                tableColumns={checkinsTbColumns}
                isPage={isPage}
                setIsPage={setIsPage}
                tablePagination={tbDatas.pagination}
              />
            </div>
          )}
        </TabPanel>
      </Tabs>
    </>
  );
};

export default TabViewCheckins;
